import React from "react";
import { useNavigate } from "react-router-dom";
import AtkButton from "../AtlaskitControls/AtkButton";

export default function QuoteProposalHeader() {

  const navigate = useNavigate();

  const onBackToLoginClicked = () => {
    navigate(`/landingpage`);
  }
  return (
    <header className="quote-proposal-header  end-0 start-0 border-bottom bg-white px-3 py-2">
      <AtkButton
        label="< Back to Toolbox"
        onClick={onBackToLoginClicked}
        className="w-auto pf-primary-btn"
      />
    </header>
  );
}
